exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".article-list-wrap{background-color:#e3e3e3;padding:20px 0 30px}.article-list-wrap .container main .header{background-color:#f6f6f6;line-height:60px;border-bottom:1px solid #e3e3e3;padding-left:38px;font-size:20px}.article-list-wrap .container main .article-list{border-bottom:none}.article-list-wrap .container main .article-list .item:last-child{border-bottom:1px solid #eee}.article-list-wrap .container main .el-pagination{padding:40px 0}", ""]);

// exports
